import React from "react";
import { ListGroup, ListGroupItem,  Badge, Card } from "reactstrap";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import icnNotaire from '../img/icn-notaire.svg';
import {
    LinkIcon,
    MapPinIcon,
    PhoneIcon,
    StarIcon
} from '@heroicons/react/16/solid'



/**fiche des notaires */
export const Fiche = styled.div `
    
    margin-top:2rem;
    .card{
        padding:2rem;
        box-shadow:0 1px 20px 0 rgb(234 244 243);
        .card-title{
            font-size: 28px;
        }
        ul.list-group{
            border:0;
            li.list-group-item{
            border:0;
            padding-left:0;
            display:flex;
            flex-direction:row;
            align-items:center;
            gap:.5rem;
            p{margin:0;}
            svg{color:#1cf36c}
            }
        }
    }
        .col-competences{
            display:flex;
            flex-direction:row;
            gap:.8rem;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
    .competence{
    border-radius: 1rem;
    padding: 1rem;
    background-color: #eaf4f3 !important;
    color: #1cf36c;
    font-size: 1rem;
    font-weight: 500;
    }
`;
export const PhotoProfil = styled.div `
width:120px;
height: 120px;
overflow:hidden;
border-radius:100px;
img{
min-width: 100%;
    width: auto;
    height: auto;
    min-height: 100%;
    max-width: 110%;
    max-height: 110%;
}

`;

export const CardNotaires = styled(Card)
`
&.reco{box-shadow: rgb(67 57 203 / 25%) 0px 4px 12px}

padding: 0;
border: 0;
border-radius: 16px;
padding: 1.5rem;
position: relative;
box-shadow: 0 1px 20px 0 #1df36c12;
display: flex !important;
flex-direction: row !important;
gap: 2rem;
align-items: center !important;
 .btn-primary{padding:10px!important;}
.badge {
    margin-top: .5rem;
    background-color: white !important;
    border: 1px solid ${props => props.theme.colors.mainDark};
    color: ${props => props.theme.colors.mainDark};
}

.head {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    justify-content: start;

    a {
        color: black !important;
        text-decoration: none;
        transition: all 1s ease-out;

        h4 {
            font-size: 1.3rem;
            font-weight: 500;
            margin: 0;
        }

        &:hover {
            h4 {
                transform: scale(1.01);
            }
        }
    }

    p {
        font-size: 14px;
        opacity: .7;
        margin: 0;
        text-align:left!important;
    }
}

img {
    width: 100px;
}

.list-group {
    border: 0;
    margin: 0;
    flex-direction: column;
    gap: .5rem;
    margin-top: 1.5rem;
    text-align: center;

    @media all and (max-width: 768px) {
        flex-direction: column;
        margin-top: 1rem;
        text-align: left;
    }

    p {
        margin: 0;
        text-align:left!important;
    }

    .list-group-item {
        gap: 18px;
        border: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.8rem;
        justify-content: start;

        svg {
            color: #4339cb;
        }
            a{
            color: inherit;
            text-decoration: none;
        }
    }
}
@media all and (max-width: 768px) {

  width:100%;
  img{width:75px;}
}
`;
export const BadgeUse = styled(Badge)
`
&.use{

color:#fff;
;
border:0;
}
`;




function CardFicheNotaire(args) {
    //console.log("args card notaire", args)
    return (
    <>
        <CardNotaires className={(args.use==="oui" ? 'reco' : '')}>
            {args.photo ? <PhotoProfil><img src={args.photo} alt={args.prenom + " "+args.nom} /></PhotoProfil> : <img src={icnNotaire} alt="notaire" />}
            
            <div>
            
                <div className="head">
                <Link to={`${args.fiche}`} target="blank">
                    <h4> {args.prenom} {" "}{args.nom}</h4>
                </Link>
                </div>
                <ListGroup horizontal>
                    
                    <ListGroupItem className='p-0'>
                        <MapPinIcon class="size-6" />
                        <p>{args.adresse} {" "} {args.cp}{" "} {args.ville}</p>
                    </ListGroupItem>
                   
                            <ListGroupItem className='p-0'>
                                <PhoneIcon class="size-6" />
                                {!args.telephone ? <p className="text-muted">non renseigné</p> : <p>{args.telephone}</p>}
                                
                            </ListGroupItem>
                        
                    {args.site &&
                        <>
                            <ListGroupItem className='p-0'>
                                <LinkIcon class="size-6"/>
                                <a href={`${args.site}?utm_source=clotere`} target="blank">Consulter le site internet</a>
                            </ListGroupItem>
                        </>
                    }
                </ListGroup>
            </div>
        </CardNotaires>
        
      </>
                  
        
    );
}

export default CardFicheNotaire;